import PropTypes from 'prop-types';
import { action, extendObservable } from 'mobx';
import { PolicyModalSectionProps } from '../PolicyModalStore';
import RadioButtonStore from '../../RadioButtonStore';

export const FileActionTypes = {
    UPLOADS_AND_DOWNLOADS: 'uploadsAndDownloads',
    UPLOADS_ONLY: 'uploadsOnly',
    DOWNLOADS_ONLY: 'downloadsOnly',
};

const DEFAULT_VALUES = {
    matchUploads: true,
    matchDownloads: true
};

export default class FileActionsStore {
    static PropType = PropTypes.shape({
        actions: RadioButtonStore.PropType.isRequired,

        ...PolicyModalSectionProps,
    });

    constructor(data = {}) {
        extendObservable(this, /** @class FileActionsStore */{
            actions: new RadioButtonStore(),

            originalValue: {},
        }, data);
    }

    setValue = action((value) => {
        value = { ...DEFAULT_VALUES, ...value };
        this.originalValue = value;
        if (value.matchUploads && value.matchDownloads) {
            this.actions.setValue(FileActionTypes.UPLOADS_AND_DOWNLOADS);
        } else if (value.matchUploads) {
            this.actions.setValue(FileActionTypes.UPLOADS_ONLY);
        } else if (value.matchDownloads) {
            this.actions.setValue(FileActionTypes.DOWNLOADS_ONLY);
        }
    });

    getValue = () => {
        const value = this.actions.getValue();
        return {
            matchUploads: [FileActionTypes.UPLOADS_AND_DOWNLOADS, FileActionTypes.UPLOADS_ONLY].includes(value),
            matchDownloads: [FileActionTypes.UPLOADS_AND_DOWNLOADS, FileActionTypes.DOWNLOADS_ONLY].includes(value),
        };
    }

    hasChanged = () => {
        const value = this.getValue();
        return value.matchUploads !== this.originalValue.matchUploads ||
            value.matchDownloads !== this.originalValue.matchDownloads;
    }

    isValid = () => {
        return !!this.actions.getValue();
    }
}
